import React from 'react';

import { Message } from 'src/core/components';
import messages from './messages';

export const OLIGO_NAME = 'oligoName';
export const RESEARCHER_NAME = 'researcherName';
export const RNA_TYPE = 'rnaType';
export const BASE_COUNT = 'baseCount';
export const SENSE_SEQUENCE = 'senseSequence';
export const SENSE_MODIFICATION = 'senseModification';
export const OVERHANG = 'overhang';
export const DUPLEX = 'duplex';
export const ANTISENSE_SEQUENCE = 'antisenseSequence';
export const ANTISENSE_MODIFICATION = 'antisenseModification';
export const ANTISENSE_OVERHANG = 'antisenseOverhang';
export const ANTISENSE_BASE_COUNT = 'antisenseBaseCount';
export const SCALE = 'scale';
export const PURITY = 'purity';
export const LOADER_NAMESPACE = 'is_loader_visible';

export const PURITY_OPTIONS = {
  DESALTED: 'DESALTED'
};

export const SCALE_OPTIONS = {
  NMOLE20: 'N_20',
  NMOLE80: 'N_80',
  UMOLE1: 'U_1',
  UMOLE1p7: 'U_1_7'
};

export const RNA_OPTIONS = {
  SI_RNA: 'siRNA',
  STEALTH_RNAI: 'Stealth'
};

export const SENSE_OPTIONS = {
  BIOTIN: 'BIO',
  FLUORESCIN: 'FLO',
  PHOSPHATE: 'PHO'
};

export const VALID_SENSE_OPTIONS = ['BIO', 'FLO', 'PHO'];

export const VALID_OVERHANG_OPTIONS = ['dTdT'];

export const JAPAN_COUNTRY_CODE = 'jp';

export const DEFAULT_SENSE_OPTIONS = [{
  label: <Message message={messages.senseModification} />,
  value: messages.senseModification.defaultMessage,
}, {
  label: <Message message={messages.biotin} />,
  value: SENSE_OPTIONS.BIOTIN,
}, {
  label: <Message message={messages.fluorescein} />,
  value: SENSE_OPTIONS.FLUORESCIN,
}, {
  label: <Message message={messages.phosphate} />,
  value: SENSE_OPTIONS.PHOSPHATE,
}];

export const JAPAN_SENSE_OPTIONS = [{
  label: <Message message={messages.senseModification} />,
  value: messages.senseModification.defaultMessage,
}, {
  label: <Message message={messages.biotin} />,
  value: SENSE_OPTIONS.BIOTIN,
}, {
  label: <Message message={messages.fluorescein} />,
  value: SENSE_OPTIONS.FLUORESCIN,
}];
